import { Component } from 'react'
import i18n from '../i18n'

// Last line of defence: a render error would otherwise leave a blank page. The
// form data sits in sessionStorage, so a reload brings the user back to where
// they were. The texts come from i18n when it is up; German defaults otherwise.
class ErrorBoundary extends Component {
	state = { hasError: false }

	static getDerivedStateFromError() {
		return { hasError: true }
	}

	componentDidCatch(error, info) {
		console.error('Unhandled render error', error, info.componentStack)
	}

	render() {
		if (!this.state.hasError) return this.props.children

		const text = (key, fallback) =>
			i18n.isInitialized
				? i18n.t(`common:errorBoundary.${key}`, { defaultValue: fallback })
				: fallback

		return (
			<div className='section-card' role='alert' style={{ margin: '40px auto', maxWidth: 560 }}>
				<h1 className='section-title'>{text('title', 'Etwas ist schiefgelaufen')}</h1>
				<p>
					{text(
						'message',
						'Die Seite konnte nicht angezeigt werden. Ihre bisherigen Eingaben bleiben in dieser Browser-Sitzung gespeichert. Laden Sie die Seite neu, um fortzufahren.'
					)}
				</p>
				<button
					type='button'
					className='btn-primary-action'
					onClick={() => window.location.reload()}
				>
					{text('reload', 'Seite neu laden')}
				</button>
			</div>
		)
	}
}

export default ErrorBoundary
